import React, { Component } from "react";
import AdvancedCommonFileSettings from "./AdvancedCommonFileSettings";

export class AdvancedSharepointSettings extends Component {
  state = {
    onlyReadSettings: [],
    doNotReadSettings: [],
    doNotSpiderSettings: [],
    childSettings: [],
  };

  render() {
    return (
      <div>
        <AdvancedCommonFileSettings
          editKs={this.props.editKs}
          setSpiderProperties={this.props.setSpiderProperties}
          sourceType="SHAREPOINT"
          onOnlyReadUpdate={this.onOnlyReadUpdate}
          onDoNotReadUpdate={this.onDoNotReadUpdate}
          onDoNotSpiderUpdate={this.onDoNotSpiderUpdate}
        />
      </div>
    );
  }

  onOnlyReadUpdate = (regexes) => {
    // let { onlyReadSharedDrives, ...unknown } = regexes;
    // let onlyReadSettings = [
    //   {
    //     key: 'sharepoint.libraries.include.reader',
    //     subsection: 'reader',
    //     value: onlyReadSharedDrives
    //   },
    // ]
    // this.setState({ onlyReadSettings });
    // if (this.props.onOnlyReadUpdate) {
    //   this.props.onOnlyReadUpdate(unknown);
    // }
  };

  onDoNotReadUpdate = (regexes) => {
    // let { doNotReadSharedDrives, ...unknown } = regexes;
    // let doNotReadSettings = [
    //   {
    //     key: 'drive.shared.exclude.reader',
    //     subsection: 'reader',
    //     value: doNotReadSharedDrives
    //   },
    // ]
    // this.setState({ doNotReadSettings });
    // if (this.props.onDoNotReadUpdate) {
    //   this.props.onDoNotReadUpdate(unknown);
    // }
  };

  onDoNotSpiderUpdate = (regexes) => {
    // let { doNotSpiderSharedDrives, ...unknown } = regexes;
    // let doNotSpiderSettings = [
    //   {
    //     key: 'drive.shared.exclude.spider',
    //     subsection: 'spider',
    //     value: doNotSpiderSharedDrives
    //   },
    // ]
    // this.setState({ doNotSpiderSettings });
    // if (this.props.onDoNotSpiderUpdate) {
    //   this.props.onDoNotSpiderUpdate(unknown);
    // }
  };
}

export default AdvancedSharepointSettings;
